module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9522_richelieu_red.b0702e97.jpg";